export default function Badge({ children, className = '' }) {
  return (
    <div
      className={`
        w-fit px-5 py-2 rounded-full font-semibold
        bg-gradient-to-r from-sky-500 to-blue-600 text-white
        select-none text-center shadow-lg ring-1 ring-white/15
        ${className}
      `.trim()}
    >
      {children}
    </div>
  );
}
